export enum OrderStatus {
  READY = "READY",
  CREATED = "CREATED",
  RUNNING = "RUNNING",
  FAILED = "FAILED",
  COMPLETED = "COMPLETED",
  ABORTED = "ABORTED",
  CANCELED = "CANCELED",
  QUEUED = "QUEUED",
  WAITING_APPROVAL = "WAITING_APPROVAL",
  STANDBY = "STANDBY",
  QUOTE_REQUESTED = "QUOTE_REQUESTED",
  QUOTE_PROPOSED = "QUOTE_PROPOSED",
  QUOTE_ACCEPTED = "QUOTE_ACCEPTED",
  QUOTE_DECLINED = "QUOTE_DECLINED",
  MANUAL_DELIVERY_BEFORE_COMPLETED = "MANUAL_DELIVERY_BEFORE_COMPLETED",
  SCHEDULED = "SCHEDULED",
  UNKNOWN = "UNKNOWN",
}
